import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/lib/i18n";

const SITE = "https://x10-management.de";

const defaults = {
  de: {
    title: "X10 Management GmbH | Prozessoptimierung, KI & Digitale Transformation",
    description:
      "X10 Management ist eine deutsche Unternehmensberatung für Prozess-Exzellenz, KI-Integration und digitale Transformation. Pragmatisch, messbar, umsetzungsstark.",
  },
  en: {
    title: "X10 Management GmbH | Process Excellence, AI & Digital Transformation",
    description:
      "X10 Management is a German consulting firm for process excellence, AI integration and digital transformation. Pragmatic, measurable, execution-focused.",
  },
};

export default function SEO({ title, description, path = "/", image }) {
  const { lang } = useLang();
  const d = defaults[lang] || defaults.de;
  const finalTitle = title ? `${title} | X10 Management GmbH` : d.title;
  const finalDesc = description || d.description;
  const url = `${SITE}${path}`;
  const ogImage =
    image ||
    "https://customer-assets.emergentagent.com/job_ai-optimize-9/artifacts/pfkbhgts_EACFFDFF-CFFC-4723-9FDD-3760F649A81E.png";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="de" href={`${SITE}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE}${path}?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE}${path}`} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="X10 Management GmbH" />
      <meta property="og:locale" content={lang === "de" ? "de_DE" : "en_US"} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "X10 Management GmbH",
        url: SITE,
        logo: `${SITE}/logo.png`,
        address: {
          "@type": "PostalAddress",
          streetAddress: "Herner Str. 299",
          postalCode: "44809",
          addressLocality: "Bochum",
          addressCountry: "DE",
        },
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+49-234-6055-0",
          email: "kontakt@x10management.de",
          contactType: "customer service",
        },
      })}</script>
    </Helmet>
  );
}
